define((require) => {
    "use strict";

    var Marionette              = require("marionette"),
        Preconditions           = require("shared/util/Preconditions"),
        _                       = require("underscore");

    var SCROLLBAR_MARGIN        = 15,
        BOUNDARY_MARGIN         = 5,
        DEFAULT_CONTAINER_SIZE  = {right: 0, bottom: 0},
        WIDGET_EVENTS           = "change:width change:height change:top change:left remove";

    return Marionette.Controller.extend({

        _viewModel: null,
        _comments: null,
        _experienceModel: null,
        _scenes: null,
        _overlayScene: null,
        _backgroundScene: null,

        initialize: function() {
            Preconditions.isModel(this.options.viewModel);
            Preconditions.isModel(this.options.experience);

            this._viewModel         = this.options.viewModel;
            this._comments          = this.options.viewModel.get("comments");
            this._experienceModel   = this.options.experience;
            this._scenes            = this.options.experience.get("scenes");
            this._overlayScene      = this.options.experience.get("overlayScene");
            this._backgroundScene   = this.options.experience.get("backgroundScene");
        },

        /**
         * Registers listeners and updates the size initially
         */
        start: function() {
            this.listenTo(this._viewModel, "change:scene", this._updateContainerSize);
            this.listenTo(this._comments, "change:left change:top add:replies remove", this._updateContainerSize);
            this._scenes.each(function(scene) {
                this.listenTo(scene.get("widgets"), WIDGET_EVENTS, this._deferredUpdateContainerSize);
            }, this);
            this.listenTo(this._overlayScene.get("widgets"), WIDGET_EVENTS, this._deferredUpdateContainerSize);
            this.listenTo(this._backgroundScene.get("widgets"), WIDGET_EVENTS, this._deferredUpdateContainerSize);

            this.listenTo(this._viewModel, "editorView:TransitionedIn", this._updateContainerSize);
        },

        /**
         * Wait for the widget element to be rendered before we check its new position.
         * Otherwise the container will update based on the old widget position (if it's
         * changed from the input fields).
         */
        _deferredUpdateContainerSize: function() {
            _.defer(this._updateContainerSize.bind(this));
        },

        /**
         * Updates the container size, so it's large enough to include all widgets
         * and all comments (to get the scrollbars)
         */
        _updateContainerSize: function() {
            var offset = this.options.container.offset(),
                widgets = this._viewModel.get("scene").get("widgets"),  // Widgets on "current scene" (collection)
                comments = this._viewModel.get("comments"),             // Comments Collection
                showComments = this._viewModel.get("showComments"),     // Whether comments are shown at all
                scale = this._viewModel.get("zoomModel").get("scale"),
                widgetsBounds = this._getElementsBounds(this.options.getWidgetBoundsProvider, widgets),
                commentsBounds = showComments ? this._getElementsBounds(this.options.commentBoundsProvider, comments) : DEFAULT_CONTAINER_SIZE;

            this.options.container.css(this._getMinWidthHeightCss(offset, scale, widgetsBounds, commentsBounds));

            this._correctOutOfBoundsWidgets(offset, this.options.getWidgetBoundsProvider, widgets);

            this._viewModel.trigger("editorView:updateContainerSize");
        },

        /**
         * Run through every widget and correct the position if it is above or to the left of the container (so
         * it is invisible and unreachable).
         */
        _correctOutOfBoundsWidgets: function(offset, boundsProvider, widgets) {
            Preconditions.isObject(offset);
            Preconditions.isFunction(boundsProvider);
            Preconditions.isCollection(widgets);

            widgets.each(function(widget) {
                var bounds = boundsProvider(widget),
                    correctionInPx,
                    correctionInPercent;

                // Moving widget back into the view from left
                if (widget.get("width") > 0 && bounds.right - offset.left - BOUNDARY_MARGIN < 0) {
                    correctionInPx = bounds.right - offset.left - BOUNDARY_MARGIN;
                    correctionInPercent = this._experienceModel.getPercentageSize({width: correctionInPx}).width;

                    widget.set("left", widget.get("left") - correctionInPercent);
                }

                // Moving widget back into the view from top
                if (widget.get("height") > 0 && bounds.bottom - offset.top - BOUNDARY_MARGIN < 0) {
                    correctionInPx = bounds.bottom - offset.top - BOUNDARY_MARGIN;
                    correctionInPercent = this._experienceModel.getPercentageSize({height: correctionInPx}).height;

                    widget.set("top", widget.get("top") - correctionInPercent);
                }
            }, this);
        },

        _getMinWidthHeightCss: function(offset, scale, widgetsBounds, commentsBounds) {
            var minWidth = Math.max(widgetsBounds.right, commentsBounds.right),
                minHeight = Math.max(widgetsBounds.bottom, commentsBounds.bottom);

            return {
                minWidth: (minWidth - offset.left) / scale + SCROLLBAR_MARGIN,
                minHeight: (minHeight - offset.top) / scale + SCROLLBAR_MARGIN
            };
        },

        /**
         * Returns and object containing the maximum right and bottom
         * of all models from a collection
         */
        _getElementsBounds: function(boundsProvider, collection) {
            Preconditions.isFunction(boundsProvider);
            Preconditions.isCollection(collection);

            // Running through each child in the collection and returns
            // the furthermost right and bottom
            return collection.reduce((memo, model) => {
                var elementBoundingBox = boundsProvider(model);

                return {
                    right: Math.max(memo.right, elementBoundingBox.right),
                    bottom: Math.max(memo.bottom, elementBoundingBox.bottom)
                };
            }, DEFAULT_CONTAINER_SIZE);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/ExperienceEditorSizeController.js